import React from 'react';
import classes from './input.module.scss'
import PropTypes from 'prop-types';

const Input = (props) => {
    const inputClasses =  props.errors[props.name] ? classes.input+' '+classes.invalid : classes.input;
    return <div className={classes.input__wrapper}>
	    		<input 
                    className={inputClasses} 
	     			ref={props.register({minLength: {value:5, message:'Min length: 5'}})}
				    type = {props.type}
				    name = {props.name}  
				    placeholder = {props.placeholder}   
				/>
				<span className={classes.input__error}>
                    {props.errors[props.name] ? props.errors[props.name].message : null}
                </span>
			</div>
}

Input.propTypes = {
    type: PropTypes.string,
    name: PropTypes.string,
    placeholder: PropTypes.string,
    onChange: PropTypes.func
}

export default Input;